














import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import AllyInputAutoComplete from '@/components/InputField/AllyInputAutoComplete.vue';
import AllyInputStatusButton from '@/components/InputField/AllyInputStatusButton.vue';

@Component({
	components: {
		AllyInputStatusButton,
		AllyInputAutoComplete,
	},
})
export default class InputField extends Vue {
	@Action private handleInput!: any;
	@Action private resetAutoCompleteText!: any;

	@State private allyPlaceholder!: string;
	@State private list!: any;
	@State private dataPanelSide!: string;

	@State private rows!: any;

	private handleInputWrapper() {
		this.handleInput();
	}
}
